<script>
/* eslint-disable semi */
import { Component, Prop } from 'vue-property-decorator';
import { SasCascader } from '@/core/ui';

@Component
export default class AppCascader extends SasCascader {
  /**
   * 拡張設定
   * changeOnSelect: 子要素を持つ要素を選択可能か否か
   * filterable: フィルター入力可否
   * api.options: オプション値を取得するAPIのURL
   */
  @Prop({required: false})
  options;

  /**
   * 末端階層以外での選択可否
   */
  get changeOnSelect () {
    return this.options.changeOnSelect;
  }

  /**
   * フィルター入力可否
   */
  get filterable () {
    return this.options.filterable;
  }

  /**
   * 選択値を取得する
   */
  fetchOptionsImpl (hierarcy) {
    const cache = (this.options.global) ? this.$_sas.$cache.global : this.$_sas.$cache;
    const url = this.options.api.options;
    return cache.segment(url).get(null, () => {
      return this.$_sas.$api.cancel().get(url)
        .then(response => {
          return response.data.results.codes;
        });
    });
  }

  onBlur (...args) {
    this.$emit('blur', ...args);

    // フォーカスが外れたタイミングでバリデーションを要求する
    this.$emit('app-event', 'require:validate', this, ...args);
  }
  onChange (...args) {
    this.$emit('change', ...args);

    // 値が変更されたタイミングでバリデーションを要求する
    this.$emit('app-event', 'require:validate', this, ...args);
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/cascader/AppCascader.vue